export const ALL_STATES_ID = 'ALL';

export const SESSION_GROUP_IDS = {
  allActive: 'ALL_ACTIVE',
  mostRecent: 'MOST_RECENT',
  mostRecentRegular: 'MOST_RECENT_REGULAR',
};

export type SessionGroupId =
  | typeof SESSION_GROUP_IDS.allActive
  | typeof SESSION_GROUP_IDS.mostRecent
  | typeof SESSION_GROUP_IDS.mostRecentRegular;

export const SESSION_GROUP_VALUES: SessionGroupId[] = [
  SESSION_GROUP_IDS.allActive,
  SESSION_GROUP_IDS.mostRecent,
  SESSION_GROUP_IDS.mostRecentRegular,
];

export const isSessionGroupId = (value: string): value is SessionGroupId => {
  for (const groupId of SESSION_GROUP_VALUES) {
    if (groupId === value) {
      return true;
    }
  }
  return false;
};

export const ENROLLED_GREEN_STATES = [
  'CO',
  'DE',
  'IA',
  'KS',
  'ME',
  'MO',
  'MS',
  'MT',
  'ND',
  'NE',
  'OH',
  'OK',
  'RI',
  'SD',
  'TX',
  'UT',
  'VT',
  'WY',
] as const;

export type EnrolledGreenState = (typeof ENROLLED_GREEN_STATES)[number];

export const isEnrolledGreenState = (stateCode: string | null | undefined): boolean => {
  if (!stateCode) {
    return false;
  }
  const normalized = stateCode.toUpperCase();
  for (const candidate of ENROLLED_GREEN_STATES) {
    if (candidate === normalized) {
      return true;
    }
  }
  return false;
};
